import { LeftOutlined } from '@ant-design/icons';
import { Avatar, Card, Progress, Typography } from 'antd';
import Meta from 'antd/es/card/Meta';
import React from 'react';
import './goalDetails.css';

const { Title, Text } = Typography;

const sampleFunds = [
  {
    name: 'Parag Parikh Flexi Cap Fund Direct Growth',
    invested: 125000,
    currentValue: 160000,
    gainLoss: 35000,
    gainLossPercentage: 28,
    schemaType: 'Multi Cap Fund',
    image: 'parag_parikh.jpg',
  },
  {
    name: 'Quant Small Cap Fund Growth Option Direct Plan',
    invested: 200000,
    currentValue: 220000,
    gainLoss: 20000,
    gainLossPercentage: 10,
    schemaType: 'Small Cap Fund',
    image: 'quant_mf.png',
  },
  {
    name: 'Canara Robeco Small Cap Fund Direct Growth',
    invested: 18000,
    currentValue: 20000,
    gainLoss: 2000,
    gainLossPercentage: 11.11,
    schemaType: 'Small Cap Fund',
    image: 'canara_rb.png',
  },
];

interface Props {
  onBack: () => void;
  name: string;
}

const GoalDetails: React.FC<Props> = ({ onBack, name }) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '0px 16px',
        boxSizing: 'border-box',
      }}
    >
      <LeftOutlined style={{ marginLeft: '0px' }} onClick={onBack} />
      <div>
        <Title level={3}>{name} Goal</Title>
        <Text>
          You are <strong style={{ color: 'green' }}>Ahead</strong> to achieve
          your goal.
        </Text>
      </div>

      <Card className='goalDetailsTarget' bordered>
        <Title
          style={{
            marginTop: 0,
            fontWeight: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          level={5}
        >
          Target: <b>5L</b>
        </Title>
        <Title
          style={{
            marginTop: 0,
            fontWeight: 400,
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          level={5}
        >
          Time: <b>24 Months</b>
        </Title>
      </Card>

      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Progress
          className='custom-progress'
          format={(percent) => (
            <span style={{ fontSize: '14px' }}>{`${percent}% Achieved`}</span>
          )}
          type='circle'
          percent={(4 / 5) * 100}
        />
        <Card
          className='investmentInfoGoals'
          bordered={false}
          hoverable={false}
        >
          <Title
            style={{ marginTop: 0, textDecoration: 'underline' }}
            level={5}
          >
            After 12 Months
          </Title>
          <Text style={{ marginTop: 5, marginBottom: 5 }}>
            Monthly SIP:{' '}
            <b>
              {(
                sampleFunds
                  .map((r) => r.invested)
                  .reduce((acc, cur) => acc + cur, 0) / 12
              ).toLocaleString('en-IN')}{' '}
              INR
            </b>
          </Text>
          <Text style={{ marginBottom: 5 }}>
            Current Value:{' '}
            <b>
              {sampleFunds
                .map((r) => r.currentValue)
                .reduce((acc, cur) => acc + cur, 0)
                .toLocaleString('en-IN')}{' '}
              INR
            </b>
          </Text>

          <Text>
            Invested:{' '}
            <b>
              {sampleFunds
                .map((r) => r.invested)
                .reduce((acc, cur) => acc + cur, 0)
                .toLocaleString('en-IN')}{' '}
              INR
            </b>
          </Text>
        </Card>
      </div>

      <Title level={5}>Allocation of Mutual Funds</Title>
      <div>
        {sampleFunds.map((fund) => (
          <>
            <Card
              style={{ width: '100%', marginTop: 10 }}
              actions={[
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '0px 16px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text style={{ display: 'flex' }}>
                        Invested
                      </Typography.Text>
                      <Typography.Text
                        style={{ display: 'flex', fontWeight: 600 }}
                      >
                        ₹ {fund.invested.toLocaleString('en-IN')}
                      </Typography.Text>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text style={{}}>
                        Current Value
                      </Typography.Text>
                      <Typography.Text
                        style={{ display: 'flex', fontWeight: 600 }}
                      >
                        ₹ {fund.currentValue.toLocaleString('en-IN')}
                      </Typography.Text>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '38%',
                      }}
                    >
                      <Typography.Text style={{ display: 'flex' }}>
                        Gain/Loss
                      </Typography.Text>
                      <Typography.Text
                        style={{ display: 'flex', fontWeight: 600 }}
                      >
                        ₹ {fund.gainLoss.toLocaleString('en-IN')}{' '}
                        <Typography.Text style={{ color: 'green' }}>
                          ({fund.gainLossPercentage}%)
                        </Typography.Text>
                      </Typography.Text>
                    </div>
                  </div>
                </div>,
              ]}
            >
              <Meta
                className='mutualFundsName'
                avatar={
                  <Avatar
                    src={`/images/${fund.image}`}
                    className='imagesMutualFunds'
                  />
                }
                title={<div>{fund.name}</div>}
                description={<div>SchemeType : {fund.schemaType}</div>}
              />
            </Card>
          </>
        ))}
      </div>
    </div>
  );
};

export default GoalDetails;
